var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9755 7.47289C17.8044 7.64258 17.5723 7.73788 17.3304 7.73782H16.4183V14.238C17.5084 14.6189 18.239 15.6392 18.2425 16.7857V18.5952C18.2426 18.8352 18.1465 19.0654 17.9755 19.2351C17.8044 19.4048 17.5723 19.5001 17.3304 19.5H0.912127C0.670197 19.5001 0.438157 19.4048 0.267086 19.2351C0.0960158 19.0654 -6.28488e-05 18.8352 0 18.5952V16.7857C0.00355578 15.6392 0.734093 14.6189 1.82425 14.238V7.73782H0.912127C0.670197 7.73788 0.438157 7.64258 0.267086 7.47289C0.0960158 7.30319 -6.28488e-05 7.07302 0 6.83304V4.11869C-0.000161205 3.72933 0.251074 3.38364 0.623521 3.26074L8.83266 0.546388C9.02002 0.484537 9.22252 0.484537 9.40988 0.546388L17.619 3.26074C17.9915 3.38364 18.2427 3.72933 18.2425 4.11869V6.83304C18.2426 7.07302 18.1465 7.30319 17.9755 7.47289ZM1.82738 16.7844V17.6892H16.4214V16.7844C16.4209 16.2849 16.0128 15.8801 15.5093 15.8796H2.73951C2.23596 15.8801 1.82788 16.2849 1.82738 16.7844ZM3.65115 14.0692V7.73568H5.4754V14.0692H3.65115ZM7.29766 7.73568V14.0692H10.9462V7.73568H7.29766ZM12.7703 14.0692V7.73568H14.5945V14.0692H12.7703ZM1.82738 4.76917V5.92666H16.4214V4.76917L9.1244 2.35611L1.82738 4.76917Z",
    fill: "#2BA355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.a21c14c8d55975545edbbbd106ab12c1.svg";
export { ForwardRef as ReactComponent };